(() => {
  'use strict';

  const ROOT_SELECTOR = '[data-sakura-collections]';

  function rootsWithin(scope) {
    const roots = [];
    if (scope.matches && scope.matches(ROOT_SELECTOR)) roots.push(scope);
    if (scope.querySelectorAll) roots.push(...scope.querySelectorAll(ROOT_SELECTOR));
    return roots;
  }

  function bind(root) {
    if (root.dataset.sakuraCollectionsBound === 'true') return;

    const tablist = root.querySelector('[data-sakura-collections-tablist]');
    const tabs = Array.from(root.querySelectorAll('[data-sakura-collections-tab]'));
    const panels = Array.from(root.querySelectorAll('[data-sakura-collections-panel]'));
    const previous = root.querySelector('[data-sakura-collections-previous]');
    const next = root.querySelector('[data-sakura-collections-next]');
    if (!tablist || !tabs.length || tabs.length !== panels.length || !previous || !next) return;

    root.dataset.sakuraCollectionsBound = 'true';

    tablist.setAttribute('role', 'tablist');
    tablist.setAttribute('aria-label', tablist.dataset.label || 'Collections');
    tabs.forEach((tab, index) => {
      tab.setAttribute('role', 'tab');
      tab.setAttribute('aria-controls', panels[index].getAttribute('id'));
      panels[index].setAttribute('role', 'tabpanel');
      panels[index].setAttribute('aria-labelledby', tab.getAttribute('id'));
    });

    const activate = (requestedIndex, moveFocus) => {
      const index = (requestedIndex + tabs.length) % tabs.length;
      tabs.forEach((tab, tabIndex) => {
        const active = tabIndex === index;
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.setAttribute('tabindex', active ? '0' : '-1');
        panels[tabIndex].hidden = !active;
      });
      root.dataset.sakuraCollectionsActive = String(index);
      if (moveFocus) tabs[index].focus();
    };

    const activeIndex = () => {
      const selected = tabs.findIndex(tab => tab.getAttribute('aria-selected') === 'true');
      return selected < 0 ? 0 : selected;
    };

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activate(index, true));
      tab.addEventListener('keydown', event => {
        let target = null;
        if (event.key === 'ArrowLeft') target = index - 1;
        if (event.key === 'ArrowRight') target = index + 1;
        if (event.key === 'Home') target = 0;
        if (event.key === 'End') target = tabs.length - 1;
        if (target === null) return;
        event.preventDefault();
        activate(target, true);
      });
    });

    previous.addEventListener('click', () => activate(activeIndex() - 1, true));
    next.addEventListener('click', () => activate(activeIndex() + 1, true));
    activate(0, false);
    root.classList.add('is-enhanced');
  }

  function init(scope = document) {
    rootsWithin(scope).forEach(bind);
  }

  window.SakuraHomeCollections = { init };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
